import React, { useState } from "react";

import axios from "axios";
// import Sidebar from "./Sidebar";
import ChatWindow from "./ChatWindow";
import ChatInput from "./ChatInput";
import Dropdown from "./Dropdown";
import FeedbackModal from "./FeedbackModal";
import RestartModal from "./RestartModal";
import SuccessModal from "./SuccessModal";

const MainPage = () => {
  const [isApiInProgress, setIsApiInProgress] = useState(false);
  const [messages, setMessages] = useState([]);
  const [response, setResponse] = useState("");
  const [showEndScreen, setShowEndScreen] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [input, setInput] = useState("");
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showRestartModal, setShowRestartModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [initialSelectedIndustry, setInitialSelectedIndustry] = useState("faq");
  const [hasUserInput, setHasUserInput] = useState(false);


  // const navigate = useNavigat();
  // const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectedIndustry, setSelectedIndustry] = useState("faq");

  const handleSend = (messageText) => {
    setHasUserInput(true);
    const currentIndustry = selectedIndustry; // Capture the selected industry at the time of sending
    setInitialSelectedIndustry(currentIndustry);
    const newMessage = { text: messageText, isUser: true };
    setMessages((prevMessages) => [...prevMessages, newMessage]);

    // const proxyUrl = "https://cors-anywhere.herokuapp.com/";
    // const apiUrl = selectedIndustry
    //   ? "https://dk-dev-hackathon.accenture.com/Sustainify/RetailAgentResponse.php?content"
    //   : "https://dk-dev-hackathon.accenture.com/Sustainify/GenerateResponse.php?content";
  
    console.log("token and user ..." , localStorage.user , localStorage.token)
    setIsApiInProgress(true);
    axios({
      data: {skill:"angular",prompt:input,user:localStorage.user.substring(0,localStorage.user.indexOf("@"))},
      headers: { "Content-Type": "application/json" ,Authorization:`${localStorage.token}` },
      method: "post",
      url: "https://wa278175geninaeuwa02-apim.azure-api.net/getAccentureContent",
    })
      .then((response) => {
        console.log("initial industry", initialSelectedIndustry);
        console.log("current industry", currentIndustry);
         console.log("response from api" , response)
          const botResponse = {
            text: response.data[0],
            isUser: false,
          };
          setMessages((prevMessages) => [...prevMessages, botResponse]);
        
        setIsApiInProgress(false);
      })
      .catch((error) => {
          console.log("Error from api" , error)
          const botResponse = {
            text: `This is the dummy response coming from api `,
            isUser: false,
          };
          setMessages((prevMessages) => [...prevMessages, botResponse]);
        
        setIsApiInProgress(false);
      });
  };
 
  const handleGenerate = (messageText) => {
    handleSend(messageText);
  };

  const handleIndustryChange = (industry) => {
    console.log(industry);

    setSelectedIndustry(industry);
    setInitialSelectedIndustry(industry);
    setIsApiInProgress(false);
    setMessages([]);
    setSuggestions([]);
    setResponse("");
    setHasUserInput(false);
  };
  const handleEndPromptClick = () => {
    setShowFeedbackModal(true);
  };
  const handleApiResponse = (apiResponse) => {
    const botResponse = { text: apiResponse, isUser: false };
    setMessages((prevMessages) => [...prevMessages, botResponse]);
  };

  // const handleRestartClick = () => {
  //   setSuggestions([]);
  //   setResponse("");
  //   setMessages([]);
  // };

  const handleRestartClick = () => {
    setShowRestartModal(true);
  };

  const handleRestartConfirm = () => {
    setShowRestartModal(false);
    setSuggestions([]);
    setResponse("");
    setMessages([]);
    setHasUserInput(false);
  };

  // const handleEndPromptClick = () => {
  //   setShowEndScreen(true);
  // };

  const handleFeedbackClick = () => {
    setShowFeedbackForm(true);
  };

  const handleFeedbackSubmit = (rating) => {
    console.log(`Feedback submitted with rating: ${rating}`);
    setMessages([]);
    setShowFeedbackModal(false);
    setShowSuccessModal(true);
  };

  if (showFeedbackForm) {
    // navigate("/feedback");
  }

  return (
    <div className="container-fluid" style={{ paddingTop: "56px" }}>
      <div className="row">
        <div className="col-2">
         
        </div>
        <div
          className={`${
            messages.length === 0 ? "col-10" : "col-10 d-flex flex-column"
          }`}
        >
          {messages.length !== 0 && (
            <ChatWindow isApiInProgress={isApiInProgress} messages={messages} />
          )}

          <ChatInput
            onGenerate={handleGenerate}
            input={input}
            setInput={setInput}
            suggestions={suggestions}
            selectedIndustry={selectedIndustry} // Pass selectedIndustry to ChatInput
          />
        </div>
      </div>
      {messages.length !== 0 && (
        <div className="row">
          <div className="col-3"></div>
          <div className="col-9">
            <div
              style={{ fontFamily: "serif" }}
              className="response-actions mt-10 d-flex justify-content-end"
            >
              <button className="btn btn-link" onClick={handleRestartClick}>
                Restart Prompt
              </button>
              <span> | </span>
              <button className="btn btn-link" onClick={handleEndPromptClick}>
                End Prompt
              </button>
              <span> | </span>
            </div>
          </div>
        </div>
      )}
      <FeedbackModal
        show={showFeedbackModal}
        handleClose={() => setShowFeedbackModal(false)}
        handleSubmit={handleFeedbackSubmit}
      />
      <RestartModal
        show={showRestartModal}
        handleClose={() => setShowRestartModal(false)}
        handleConfirm={handleRestartConfirm}
      />
      <SuccessModal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
      />
      ;
    </div>
  );
};

export default MainPage;
